import {
  CloseCircleFilled,
  ExclamationCircleFilled,
  InfoCircleFilled,
} from '@ant-design/icons';
import { theme } from 'configs/styled';
import React from 'react';

export interface IAlert {
  type: 'info' | 'warning' | 'error';
  message?: string;
  title?: string;
  bulletLists?: string[];
  style?: React.CSSProperties;
}

const alertType = {
  info: {
    style: {
      border: `1px solid ${theme.palettes.alert.info.border}`,
      backgroundColor: theme.palettes.alert.info.background,
    },
    icon: (
      <InfoCircleFilled style={{ color: theme.palettes.alert.info.icon }} />
    ),
  },
  error: {
    style: {
      border: `1px solid ${theme.palettes.alert.error.border}`,
      backgroundColor: theme.palettes.alert.error.background,
    },
    icon: (
      <CloseCircleFilled style={{ color: theme.palettes.alert.error.icon }} />
    ),
  },
  warning: {
    style: {
      border: `1px solid ${theme.palettes.alert.warning.border}`,
      backgroundColor: theme.palettes.alert.warning.background,
    },
    icon: (
      <ExclamationCircleFilled
        style={{ color: theme.palettes.alert.warning.icon }}
      />
    ),
  },
};

const BulletList: React.FC<{ items: string[] }> = ({ items }) => {
  return (
    <ul style={{ paddingLeft: theme.spacing.xl, margin: '0' }}>
      {items.map((message: string, index: number) => {
        return <li key={`${index}`}>{message}</li>;
      })}
    </ul>
  );
};

const Alert: React.FC<IAlert> = props => {
  const { type, message, title, bulletLists, style } = props;
  const alert = alertType[type];

  return (
    <div
      style={{
        ...alert.style,
        padding: `${theme.spacing.sm} ${theme.spacing.md}`,
        display: 'flex',
        borderRadius: theme.spacing.xxs,
        ...style,
      }}
    >
      <div
        style={{
          width: '28px',
          maxWidth: 'fit-content',
          marginRight: theme.spacing.sm,
        }}
      >
        {alert.icon}
      </div>
      <div>
        {title && <p style={{ margin: '0' }}>{title}</p>}
        {message && <p style={{ margin: '0' }}>{message}</p>}
        {bulletLists && <BulletList items={bulletLists} />}
      </div>
    </div>
  );
};

Alert.defaultProps = {
  message: '',
};

export default Alert;
